export interface EventBadgesProps {
  innerPage: string
  design?: boolean
  onClick?: (path: string) => void
  onNavigateBack?: () => void
}

export interface EventBadgeParams {
  type: EVENT_BADGE
}

export enum EVENT_BADGE {
  FIRST_PRIORITY = 'first-priority',
  SECOND_PRIORITY = 'second-priority',
  THIRD_PRIORITY = 'third-priority',
}
